import React from 'react';

function DominosAppImg() {
    return (
        <img src={require('./DominosApp.PNG')} alt='DominosApp.PNG' />
    );
}

export default DominosAppImg;